<template>
  <div>login</div>
</template>

<script>
export default {
  name: "login"
}
</script>

<style scoped>

</style>